import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../lib/api";
import PressReleaseList from "../components/PressReleaseList";

function groupByDate(items) {
  const groups = new Map();
  for (const it of items) {
    const key = it.date || "—";
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(it);
  }
  // Map preserves insertion order; items are already sorted by date desc upstream.
  return Array.from(groups.entries());
}

function formatHeading(iso) {
  const m = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  // Build local date avoiding TZ shift (parse as UTC noon, render in es-MX)
  const d = new Date(`${iso}T12:00:00Z`);
  return d
    .toLocaleDateString("es-MX", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    .toUpperCase();
}

export default function Comunicados() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let cancelled = false;
    http
      .get("/press-releases", { params: { limit: 500 } })
      .then(({ data }) => {
        if (!cancelled) setItems(data);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-12 py-10 animate-fade-in" data-testid="comunicados-page">
      <div className="border-b-2 border-ink pb-3 mb-6">
        <p className="section-eyebrow">Gobierno Federal</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl">Comunicados de las Secretarías de Estado</h1>
        <p className="text-sub text-sm mt-2 max-w-3xl">
          Curaduría editorial de los comunicados oficiales más relevantes del día. Cada nota abre el
          comunicado original publicado por la dependencia federal.
        </p>
      </div>

      <Link
        to="/"
        className="inline-block mb-6 font-mono text-[12px] uppercase tracking-widest text-sub hover:text-rojo"
        data-testid="back-home"
      >
        ← Volver a la portada
      </Link>

      {items === null && (
        <p className="text-sub text-sm" data-testid="comunicados-loading">Cargando…</p>
      )}

      {items?.length === 0 && (
        <p className="text-sub text-sm" data-testid="comunicados-empty">
          No hay comunicados publicados todavía. La sección se actualiza cada día desde la curaduría editorial.
        </p>
      )}

      {items && items.length > 0 && (
        <div className="space-y-10" data-testid="comunicados-groups">
          {groupByDate(items).map(([day, rows]) => (
            <section key={day}>
              <h2 className="font-mono text-[12px] uppercase tracking-[0.2em] text-rojo border-b border-rule pb-1 mb-2">
                {formatHeading(day)} · {rows.length}
              </h2>
              <PressReleaseList items={rows} testId={`day-${day}`} />
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
